module.exports = __webpack_public_path__ + "img/filter.0018f2f9.svg";